export const handleError = (error: unknown) => {
  console.error('An error occurred:', error)
}

export const saveToStorage = (value: unknown, name: string) => {
  if (typeof window == 'undefined') {
    return null
  }
  try {
    const serializedState = JSON.stringify(value)
    localStorage.setItem(name, serializedState)
  } catch (err: unknown) {
    handleError(err)
  }
}

export const loadFromStorage = (name: string) => {
  if (typeof window == 'undefined') {
    return null
  }
  try {
    const serializedState = localStorage.getItem(name)
    if (serializedState === null) {
      return null
    }
    return JSON.parse(serializedState)
  } catch (err: unknown) {
    handleError(err)
    return ''
  }
}
export const removeFromStorage = (name: string) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    localStorage.removeItem(name)
  } catch (err: unknown) {
    handleError(err)
  }
}
